<template>
    <!-- 化妆师路由 -->
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    
}
</script>
